// removed by extract-text-webpack-plugin
module.exports = {"tile":"tile__2GEcD","tileDescription":"tileDescription__3t4tN","tileDescriptionHeader":"tileDescriptionHeader__2tEV7","tileDescriptionContent":"tileDescriptionContent__2YQxv","tileImageContainer":"tileImageContainer__3P_Y_","slick-slide":"slick-slide__3D_uF","imageTile":"imageTile__Z2-XK"};


//////////////////
// WEBPACK FOOTER
// ./components/buyWithInstacredLanding/merchants/style.css
// module id = +Xhx
// module chunks = 323 333